import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const VonGraefeConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Von Graefe",
  title: "Von Graefe",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.Select,
      accessor: "Eye",
      Header: "Eye",
      options: ["OD", "OS", "OU"],
    },
    {
      dataType: InputTypes.Select,
      accessor: "Distance",
      Header: "Distance",
      options: ["Near", "Distance"],
    },
    {
      dataType: InputTypes.Select,
      accessor: "Base Direction",
      Header: "Base Direction",
      options: ["BI", "BO", "BU", "BD"],
    },
    {
      dataType: InputTypes.Number,
      accessor: "Blur",
      Header: "Blur",
    },
    {
      dataType: InputTypes.Number,
      accessor: "Break",
      Header: "Break",
    },
    {
      dataType: InputTypes.Number,
      accessor: "Recovery",
      Header: "Recovery",
    },
  ],
};
